<template>
    <svg viewBox="-100 -100 225 225" xmlns="http://www.w3.org/2000/svg">
        <linearGradient :id="gradientId" x1="70.711%" x2="0%" y1="70.711%" y2="0%">
            <stop offset="0%" :stop-color="gradient.start" stop-opacity="1"/>
            <stop offset="100%" :stop-color="gradient.stop" stop-opacity="1"/>
        </linearGradient>
        <path :fill="fill"/>
    </svg>
</template>

<script>
    export default {
        name: "morph",
        props: {
            gradientId: {
                type: String,
                required: true
            },
            gradient: {
                type: Object,
                required: true
            }
        },
        computed: {
            fill () {
                return `url(#${this.gradientId})`
            }
        }
    }
</script>

<style scoped lang="scss">
    @keyframes morph {
        0%, 100% {
            d:path('M42.8,-46.4C59.1,-37.2,78.7,-27.3,85.4,-11.7C92.2,3.8,86.1,25,73.7,39C61.4,52.9,42.8,59.7,23.9,67.2C5,74.7,-14.1,83,-26.5,76.7C-38.9,70.5,-44.6,49.8,-52.2,32.2C-59.8,14.7,-69.3,0.4,-70.1,-15.5C-71,-31.3,-63.3,-48.8,-50.2,-58.5C-37,-68.3,-18.5,-70.3,-2.7,-67.2C13.2,-64,26.4,-55.6,42.8,-46.4Z')
        }
        25%  {
            d:path('M42.7,-50.2C55.4,-40.2,65.8,-26.8,68.7,-12C71.5,2.9,66.7,19.3,59,35.6C51.4,51.8,41,67.8,26.2,74.2C11.4,80.6,-7.8,77.2,-24.5,70C-41.2,62.7,-55.4,51.5,-63.2,37C-71,22.5,-72.4,4.7,-67.7,-10.2C-63,-25.1,-52.1,-37.2,-39.9,-47.2C-27.6,-57.2,-13.8,-65.1,0.6,-65.8C15,-66.5,30,-60.1,42.7,-50.2Z')
        }
        50% {
            d:path('M33.3,-38.1C43.7,-31,52.9,-21,60.9,-6.3C68.8,8.5,75.4,27.9,69.6,42.4C63.9,56.9,45.8,66.6,26.5,74.1C7.2,81.7,-13.2,87.1,-31,82.1C-48.8,77,-64,61.3,-72.1,43.5C-80.2,25.6,-81.3,5.5,-77.6,-13.4C-73.9,-32.2,-65.3,-50,-51.6,-56.5C-37.9,-62.9,-18.9,-58.2,-3.7,-53.7C11.5,-49.3,22.9,-45.2,33.3,-38.1Z')
        }
        75% {
            d:path('M42.1,-46.6C56.2,-38.4,70.4,-26.6,75.5,-11.3C80.7,4.1,76.9,23.2,67.5,38.7C58.2,54.2,43.4,66.3,25.5,74.7C7.7,83.2,-13.1,88.2,-28.3,81.2C-43.6,74.2,-53.3,55.3,-63.2,37C-73.1,18.8,-83.2,1.2,-81.7,-15.6C-80.2,-32.3,-67,-48.2,-51.4,-56.1C-35.9,-64.1,-17.9,-64,-2,-61.7C14,-59.4,28,-54.8,42.1,-46.6Z')
        }
    }

    svg {
        path {
            d:path('M45.9,-53.5C61.9,-41.4,78.7,-29.1,82.7,-13.5C86.7,2.1,77.9,21,66.7,36.9C55.6,52.8,42.1,65.8,26.7,70C11.2,74.2,-6.3,69.7,-22.3,63.1C-38.4,56.5,-53.1,47.8,-60.5,35C-67.8,22.1,-67.8,5.1,-65.5,-12.2C-63.2,-29.5,-58.7,-47,-47.4,-60C-36.1,-72.9,-18.1,-81.3,-1.5,-79.5C15,-77.6,30,-65.7,45.9,-53.5Z');
            animation: morph #{random(10) + 30}s infinite;
            animation-timing-function: ease-in-out;
        }
    }
</style>
